import { render, staticRenderFns } from "./PreviewWaybill.vue?vue&type=template&id=2d0ef1a4&scoped=true"
import script from "./PreviewWaybill.vue?vue&type=script&lang=js"
export * from "./PreviewWaybill.vue?vue&type=script&lang=js"
import style0 from "./PreviewWaybill.vue?vue&type=style&index=0&id=2d0ef1a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0ef1a4",
  null
  
)

export default component.exports